import PromotionalRibbon from "@/components/PromotionalRibbon";
import { Image } from "@/components/image";
import { NoImage } from "@/components/no-image/NoImage";
import { ZoomableImage } from "@/components/ui";
import { FLY_ORIGIN_ATTR, FLY_ORIGIN_ITEM_DETAIL } from "@/lib/fly-to-cart";
import type { Ref } from "react";

const IMAGE_CORNER_FADE = "radial-gradient(circle at 0% 0%, rgba(0,0,0,0.55) 0, rgba(0,0,0,0.55) 0%, black 10%)";

type ItemHeroProps = {
  name: string;
  imageUrl?: string;
  imageCrc?: string;
  onZoom: () => void;
  isPromotional?: boolean;
  promotionalText?: string;
  flyOrigin?: boolean;
  containerRef?: Ref<HTMLDivElement>;
};

/** Photo band of an item detail: corner-faded for the back button, zoomable, with the promo ribbon. */
export function ItemHero({
  name,
  imageUrl,
  imageCrc,
  onZoom,
  isPromotional,
  promotionalText,
  flyOrigin = false,
  containerRef,
}: ItemHeroProps) {
  const flyAttr = flyOrigin ? { [FLY_ORIGIN_ATTR]: FLY_ORIGIN_ITEM_DETAIL } : undefined;

  return (
    <div ref={containerRef} className="relative h-36 w-full overflow-hidden md:h-64" {...flyAttr}>
      <PromotionalRibbon isPromotional={isPromotional} text={promotionalText} />
      <div style={{ WebkitMaskImage: IMAGE_CORNER_FADE, maskImage: IMAGE_CORNER_FADE }}>
        {imageUrl ? (
          <ZoomableImage onZoom={onZoom} label={`Ampliar imagem de ${name}`} className="w-full">
            <Image
              width={1024}
              height={1024}
              alt={name}
              src={imageUrl}
              crc={imageCrc}
              priority
              className="h-36 w-full object-cover md:h-64"
            />
          </ZoomableImage>
        ) : (
          <NoImage width={500} height={500} alt={name} className="h-36 w-full object-cover md:h-64" />
        )}
      </div>
    </div>
  );
}
